/* unplugin-vue-components disabled */import { render } from "./demologin.vue?vue&type=template&id=165ed7c4&scoped=true"
import script from "./demologin.vue?vue&type=script&lang=js"
export * from "./demologin.vue?vue&type=script&lang=js"

import "./demologin.vue?vue&type=style&index=0&id=165ed7c4&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165ed7c4"]])

export default __exports__